/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>系统退款</public-title>
    <div class="bg-white load-area">
      <!-- <div class="text-left mb-3">
        实付金额总计：<span class="text-danger mr-4">{{totalPayMoney / 100 | formatMoney}}元</span>
        第三方平台手续费：<span class="text-danger mr-4">{{totalEndMoney / 100 | formatMoney}}元</span>
        结算金额总计：<span class="text-danger">{{((Number(totalPayMoney) - parseInt(totalEndMoney)) / 100).toFixed(2) | formatMoney}}元</span>
      </div> -->
      <div class="d-center-between flex-wrap">
        <left-text-border class="w-45 mb-3" leftText="退款ID" v-model="searchData.rid" @enter="confirmSearch"/>
        <left-text-select class="w-45 mb-3" leftText="支付类型" :options="$GVAR.payChannel" v-model="searchData.channel_type"/>
        <left-text-border class="w-45 mb-3" leftText="交易ID" v-model="searchData.tid" @enter="confirmSearch"/>
        <left-text-select class="w-45 mb-3" leftText="交易状态" :options="$GVAR.Refund " v-model="searchData.status" @enter="confirmSearch"/>
        <left-text-border class="w-45 mb-3" leftText="渠道退款号" v-model="searchData.channel_refund_no" @enter="confirmSearch"/>
        <div class="w-45 mb-3 d-center-start" >
          <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width:260px;">
            <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
          <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                  v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                  range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                  end-placeholder="结束时间" />
          <el-date-picker type="date" v-model="timetime" class="w-100" size="small" 
                          v-show="timeType === 'timeArr'" placeholder="可选择一个日期"/>
        </div>
      </div>
      <div class="d-center-between mb-3">
          <div class="text-left ml-2  totals">
              <p>统计:</p>
              <p>原支付费用：{{AdminDataLists.info.total.total_fee_total /100 | formatMoney}} 元</p>
              <p>退款总费用：{{AdminDataLists.info.total.refund_fee_total /100 | formatMoney}} 元</p>
              <p>用户实际支付费用：{{AdminDataLists.info.total.payer_total_fee_total /100 | formatMoney}} 元</p>
              <p>用户实际退款总费用：{{AdminDataLists.info.total.payer_refund_fee_total /100 | formatMoney}} 元</p>
          </div>
          <el-button type="success" size="small" @click="loadTable" class="loadTable">下载表单</el-button>
          <el-button type="primary" size="small" @click="confirmSearch">搜索</el-button>
        </div>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else class="el-tables">
        <template>
          <el-table
            :data="AdminDataLists.lists"
            :summary-method="getSummaries"
             show-summary
            border
            stripe
            max-height="780"
            style="width: 100%">
            <!--表单内容-->
            <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
              <!-- 自定义表头 -->
              <template slot="header" slot-scope="scope">
                <span>{{ scope.column.label }}</span>
                <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
              </template>
              <template slot-scope="scope">
                <!--时间-->
                <div :class="{'text-center':item.center}" v-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
                <!--金额-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='money'">{{ scope.row[item.prop]/100 | formatMoney}}</div>
                <!--状态-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='status'">{{ scope.row[item.prop]| formatVar('Refund')}}</div>
                <!--支付类型-->  
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='type'">{{ scope.row[item.prop]| formatVar('payChannel')}}</div>
                <!--其他-->
                <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next, sizes" class="mt-4" :page-sizes="[10,15,20,30]" :page-size="Formdata.num" @size-change="handleSizeChange"
                       :total="AdminDataLists.total" :current-page="Number(Formdata.page)" @current-change="handleCurrentChange"/>
        </template>
        <!-- <ul class="list-head mt-3">
          <li  v-for="item in titleArr" :key="item" :class="item=='渠道退款号'||item=='渠道交易号'? 'w-80' : 'w-50'" v-html="item"></li>
        </ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col flex-column breakword">{{item.rid}}</li>
          <li class="w-50 list-item-col">{{item.channel_type | formatVar('payChannel')}}</li>
          <li class="w-80 list-item-col">{{item.channel_refund_no}}</li>
          <li class="w-50 list-item-col goHotelDetail" @click="goHotelDetail(item.tid)">{{item.tid}}</li>
          <li class="w-80 list-item-col">{{item.channel_trade_no}}</li>
          <li class="w-50 list-item-col">{{item.total_fee/100 | formatMoney}}</li>
          <li class="w-50 list-item-col">{{item.refund_fee/100 | formatMoney}}</li>
          <li class="w-50 list-item-col">{{item.payer_total_fee/100 | formatMoney}}</li>
          <li class="w-50 list-item-col">{{item.payer_refund_fee/100 | formatMoney}}</li>
          <li class="w-50 list-item-col">{{item.status | formatVar('Refund')}}</li>
          <li class="w-50 list-item-col">{{item.user_received_account}}</li>
          <li class="w-50 list-item-col">{{item.add_time | formatTimestamp(1)}}</li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/> -->
      </div>
    </div>
       <el-dialog title="交易详情" :visible.sync="dialogDLiest" width="40%" class="paymentist" >
      <div class="d-flex flex-wrap">
        <div class=" w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
          <div class="w-100 d-center-start" v-if="item.value=='total_fee'||item.value=='payer_total_fee'||item.value=='refund_fee'">
            <left-text :leftText="item.name" /><span :class="item.color?item.color:''">{{currentItem[item.value]/100| formatMoney}}元</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value==='channel_type'">
             <left-text :leftText="item.name"/><span >{{currentItem[item.value]| formatVar('payChannel')}}</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value==='status'">
             <left-text :leftText="item.name"/><span >{{currentItem[item.value]| formatVar('Refund')}}</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value==='add_time'">
             <left-text :leftText="item.name"/><span>{{currentItem[item.value]| formatTimestamp(1)}}</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value!='payer_total_fee'&&item.value!='add_time'&&item.value!='refund_fee'&&item.value!='total_fee'&&item.value!='status'&&item.value!='channel_type'">
             <left-text :leftText="item.name"/><span :class="item.color?item.color:''" v-html="currentItem[item.value]"></span>
          </div>
        </div>
      </div>
        <div slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogDLiest = false">关闭</el-button> -->
            <el-button type="primary" @click="dialogDLiest = false">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'IncomeList',
    computed: {
      ...mapState(['AdminDataLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      titleArr() {
        let arr = ['退款ID','渠道类型','渠道退款号','交易ID','渠道交易号','原支付费用(元)','退款总费用(元)','用户实际\n支付费用(元)','用户实际收到\n的退款费用(元)','退款状态','退款入帐账户','退款时间'];
        for(let i in arr){
          arr[i]=arr[i].replace(/\n/g, '<br/>')
        }
        return arr;
      },
      timeChoose() {
        let arr =  [
          {name:`按时间段`,value:'timeFrame'},
          {name:`按日期`,value:'timeArr'},
        ];
        return arr
      },
    },
    watch:{},
    created() { 
      // 读取本地缓存
      const cache = JSON.parse(localStorage.getItem('refundCache') || '{}');
      // 有缓存就回填表单
       if (this.$route.query) this.Formdata.page = Number(this.$route.query.page||1);
      if (cache.num) this.Formdata.num = Number(cache.num);
      this.getDataLists(); 
    },
    data() {
      return {
        fundsForm:[ 
          {name:'退款ID',prop:'rid',center:true,width:150},
          {name:'渠道类型',prop:'channel_type',width:100,center:true,pattern:'type'},
          {name:'渠道退款号',prop:'channel_refund_no',minWidth:250,center:true},
          {name:'交易ID',prop:'tid',width:150,center:true},
          {name:'渠道交易号',prop:'channel_trade_no',center:true,minWidth:250},
          {name:'原支付费用(元)',prop:'total_fee',center:true,minWidth:150,pattern:'money'},
          {name:'退款总费用(元) ',prop:'refund_fee',center:true,width:150,pattern:'money'},
          {name:`用户实际支付费用(元)`,prop:'payer_total_fee',center:true,minWidth:150,pattern:'money'},
          {name:`用户实际收到的退款费用(元)`,prop:'payer_refund_fee',center:true,minWidth:150,pattern:'money'},          
          {name:'退款状态',prop:'status',center:true,width:150,pattern:'status'},
          {name:'退款入帐账户',prop:'user_received_account',center:true,width:150},
          {name:'退款时间',prop:'add_time',center:true,width:200  ,pattern:'time'},
        ],
        dialogDLiest:false,
        timeType:'timeFrame',
        timestamp: [],
        timetime:'',
        showDetail:false,
        currentItem:{},     
        out_trade_no:'',
        is_merge:false,
        Formdata:{
            num:10,                              //每页显示条数
            page:1,                              //当前页
        },
        searchData:{
            rid:'',                             //订单ID
            tid:'',                             //交易ID
            channel_type:'0',                    //渠道类型
            channel_refund_no:'',                //渠道交易号
            status:'',                          //交易状态
        },
        showDetailArr:[
          {name:'交易ID',value:'tid'},{name:'渠道类型',value:'channel_type'},{name:'订单ID',value:'oid'},{name:'渠道交易号',value:'channel_trade_no'},
          {name:'银行类型',value:'bank_type'},{name:'总费用',value:'total_fee'},{name:'费用类型',value:'fee_type'},{name:'实际支付费用',value:'payer_total_fee'},{name:'支付费用类型',value:'payer_fee_type'},{name:'已退费用',value:'refund_fee'},{name:'交易类型',value:'trade_type'},
          {name:'交易状态',value:'status'},{name:'交易时间',value:'add_time',color:'red'},
        ],
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSetInvoice','adminTradeInfo','POST_Admin_DownloadForm']),
      //确认搜索
      confirmSearch(){
          this.Formdata.page=1;
          this.getDataLists();
      },
      //点击交易详情
      goHotelDetail(item) {
        let data={
          tid:item
        }
        this.adminTradeInfo({
              data,
              successFun: (res) => {
                this.currentItem=res.info;
                this.dialogDLiest=true;
              }
        });
      },
      //设置分页数量
      handleSizeChange(val) {
        this.Formdata.num = val;
        this.updateQuery({ num: val })
        this.getDataLists();
      },
      //设置当前页
      handleCurrentChange(val) {
        // 把参数存进路由地址栏，页面不动
        this.Formdata.page = val;
        this.updateQuery({ page: val });
        this.getDataLists();
      },
      // 统一更新路由方法
      updateQuery(query) {
        this.$router.replace({
          query: { ...this.$route.query, ...query }
        });
        // 2. 存入本地存储
        let cache = JSON.parse(localStorage.getItem('refundCache') || '{}')
        localStorage.setItem('refundCache', JSON.stringify({ ...cache, ...query }))
      },
      //底部合计
      getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '小计';
                return;
              }
              const excludeFields = ['add_time', 'status', 'store_type', 'handle_time', 'oid', 'add_time','bank_card','channel_type','channel_trade_no','channel_refund_no','tid'];
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(isNaN) && !excludeFields.includes(column.property)) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] = (sums[index]/100).toFixed(2);
              } else {
                sums[index] = '';
              }
            });
            return sums;
      },
      //获取搜索表单
      getSearchForm() {
        let data={
          ...this.Formdata,
          ...this.searchData,
        };
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
           let timeArr = this.timetime?this.timetime.getTime() / 1000:'';
            data.add_time = timeArr;
            break;
          case 'timeFrame':
            data.add_time = start?start+','+end:'';
            break;
        }
        return data;
      },
      //获取交易记录列表
      async getDataLists() {
        await this.getAdminDataLists({
          type:'RefundList',
          data:this.getSearchForm(),
        });
        // this.totalPayMoney = resInfo.total_pay_money || 0;
        // this.totalEndMoney = resInfo.total_end_money || 0;
      },
      //待付款下载表单
      loadTable(){
        this.POST_Admin_DownloadForm({data:this.getSearchForm(),type:4})
      },
    }
  }
</script>
<style lang="css" scoped>
  .refund_fee{
    font-size: 13px;
    margin-top: 2px;
    color:brown;
  }
  .list-item-col{
    white-space: pre-line;
  }
  .goHotelDetail{
    cursor: pointer;

  }
 .goHotelDetail:hover{
    color: var(--smtc-color-primary); 
  }
  .totals{
    display: flex;
  } 
  .totals p{
    border-left: 1px #eee solid;
    padding: 0 10px;
    color: #666;
  }
  .totals p:nth-child(1),
  .totals p:nth-child(2) {
    border-left: none;
    padding-left: 0;
  }
    .loadTable{
    margin-left: auto;
  }
</style>